import { createTheme } from '@mui/material/styles'
import { BUTTON_TRANSITION } from './buttonHover'
import { palette } from './palette'
import { typography } from './typography'
import { scale } from './scale'
const theme = createTheme({
  palette,
  typography,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          fontFamily: typography.fontFamily,
        },
        body: {
          fontFamily: typography.fontFamily,
          fontWeight: 400,
          fontStyle: 'normal',
        },
        '#root': {
          fontFamily: typography.fontFamily,
        },
        '*, *::before, *::after': {
          fontFamily: 'inherit',
        },
        button: {
          fontFamily: typography.fontFamily,
          transition: BUTTON_TRANSITION,
        },
        input: {
          fontFamily: typography.fontFamily,
        },
        textarea: {
          fontFamily: typography.fontFamily,
        },
        select: {
          fontFamily: typography.fontFamily,
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        fontFamily: typography.fontFamily,
      },
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily,
          fontWeight: 400,
          fontStyle: 'normal',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily,
          textTransform: 'none',
          borderRadius: 50,
          minHeight: 45,
          height: 'auto',
          padding: '14px',
          fontSize: 16,
          fontWeight: 400,
          fontStyle: 'normal',
          boxSizing: 'border-box',
          width: 'fit-content',
          maxWidth: '100%',
          minWidth: 'unset',
          whiteSpace: 'nowrap',
          transition: BUTTON_TRANSITION,
        },
        contained: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlined: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: BUTTON_TRANSITION,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          transition: BUTTON_TRANSITION,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily,
        },
        input: {
          fontFamily: typography.fontFamily,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            minHeight: scale.size.lg,
          },        },
      },
    },
  },
})

export default theme
